<template>
  <q-card flat>
    <q-card-section>
      Abbreviate financial period in charts using start or end year
      <q-separator class="q-mt-sm q-mb-sm" />
      <span class="text-caption text-grey-6">
        If your financial period was 01/07/2020 - 30/06/2021, would you abbreviate it as 2020 (using start year) or 2021
        (using end year)?
      </span>
    </q-card-section>

    <q-card-section>
      <div class="row q-col-gutter-lg">
        <q-select v-model="value" :options="options" emit-value map-options outlined class="col-xs-6" />
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  data: () => ({
    value: null,
    options: [
      { label: 'Start year', value: 'start_date' },
      { label: 'End year', value: 'end_date' }
    ]
  }),

  created() {
    this.value = this.settings.financial_period_display_using_date
  },

  methods: {
    getData() {
      return this.value
    }
  }
}
</script>
